import * as api from "../api/brandingApi";
import { BRANDING_RECEIVED } from "../constants/ActionTypes";
import { updateIntl } from "react-intl-redux";
import { getLanguage } from "../utils/languageMap";

export const DEFAULT_BRANDING = {
  login: {
    login_label: "",
    password_instruction: null,
    background: {
      image_url: "",
      overlay_color: "#000000",
      opacity: 0
    },
    help: {
      link_text: "",
      instructions: ""
    },
    mfa: {
      mfa_enrollment_message: ""
    },
    footer: {
      hide_onelogin_footer: false
    },
    forgot_password_link: {
      show_forgot_password_link: true
    }
  },
  common: {
    accent_color: "#0093c3",
    primary_color: "#000000",
    logo_url: "/images/logo_default@2x.png"
  },
  support: {
    enable_spam_protection: false,
    enable_support: false,
    email: "",
    instructions: ""
  },
  lang: {
    default: "",
    supported: []
  }
};

export const fetchBranding = () => async dispatch => {
  try {
    const branding = await api.fetchBranding();
    const languageTag = window?.navigator?.language || "en";
    dispatch({
      type: BRANDING_RECEIVED,
      data: branding
    });
    dispatch(
      updateIntl({
        locale: languageTag,
        messages: getLanguage(languageTag)
      })
    );
  } catch (err) {
    dispatch({
      type: BRANDING_RECEIVED,
      data: DEFAULT_BRANDING
    });
  }
};
